import { lazy } from "react";

export const publicRoutes = [
  {
    path: "/login",
    component: lazy(() => import("../pages/auth/login")),
  },
  {
    path: "/verify-otp",
    component: lazy(() => import("../pages/auth/verifyOTP.jsx")),
  },
  {
    path: "/forgot-password",
    component: lazy(() => import("../pages/auth/forgotPassword.jsx")),
  },
  {
    path: "/forgot-password/verify",
    component: lazy(() => import("../pages/auth/forgotPasswordOtp.jsx")),
  },
  {
    path: "/change-password",
    component: lazy(() => import("../pages/auth/changePassword.jsx")),
  },
];

export const protectedRoutes = [
  {
    path: "/profile",
    component: lazy(() => import("../components/profile/profile.jsx")),
  },
  {
    path: "/dashboard",
    component: lazy(() => import("../components/dashboard/dashboard.jsx")),
  },
  {
    path: "/patients",
    component: lazy(() => import("../components/patients/patients.jsx")),
  },
  {
    path: "/patients/:id",
    component: lazy(() => import("../components/patients/patientDetails.jsx")),
  },
  {
    path: "/doctors-kyc",
    component: lazy(() => import("../components/doctorKyc/doctorKyc.jsx")),
  },
  {
    path: "/doctors-kyc/pending/:id",
    component: lazy(() =>
      import("../components/doctorKyc/doctorKycDetails.jsx")
    ),
  },
  {
    path: "/doctors-kyc/doctor/:id",
    component: lazy(() => import("../components/doctorKyc/doctorProfile.jsx")),
  },
  {
    path: "/document",
    component: lazy(() => import("../components/document/document.jsx")),
  },
  {
    path: "/locker-and-sharing",
    component: lazy(() =>
      import("../components/lockerAndSharing/lockerAndSharing.jsx")
    ),
  },
  {
    path: "/support-and-assistance",
    component: lazy(() =>
      import("../components/SupportAndAssistance/supportAndAssistance.jsx")
    ),
  },
  {
    path: "/support-and-assistance/ticket-details/:id",
    component: lazy(() =>
      import("../components/SupportAndAssistance/supportAssistanceDetails.jsx")
    ),
  },
];
